<div class="section" [ngClass]="isWarning ? 'warning' : ''">
  <app-text-divider>{{ sectionTitle }}</app-text-divider>
  <ng-content></ng-content>
</div>